import { isValidPhoneNumber } from 'react-phone-number-input';
import { hasBlockedBookingTime, temporaryClosureMessageKey } from './booking-availability';

// Stato iniziale del form
export const initialState = {
    checkin_date: '',
    checkin_time: '',
    checkout_date: '',
    checkout_time: '',
    vehicles: [{ vehicleType: '', vehicleLength: '', services: '' }],
    has_transfer: false,
    transfer_type: '',
    passengers_outbound: 0,
    dropoff_place: '',
    dropoff_place_detail: '',
    embark_detail: '',
    passengers_return: 0,
    pickup_place: '',
    pickup_place_detail: '',
    disembark_detail: '',
    disembark_time: '',
    train_arrival_time: '',
    pickup_time: '',
    total_quotation: 0,
    customer_name: '',
    customer_surname: '',
    customer_email: '',
    customer_phone: '',
    message: '',
    personal_data: false,
    payment_terms: false,
};

// Funzione di validazione per i singoli step
export const validateStep = (step, formData) => {
    // Runs when advancing, requesting a quote and confirming the booking.
    if (hasBlockedBookingTime(formData, step >= 3)) {
        return { isValid: false, messageKey: temporaryClosureMessageKey };
    }
    if (step > 1) {
        const dates = validateStep(1, formData);
        if (!dates.isValid) return dates;
    }
    if (step === 5) {
        const transfer = validateTransferStep(formData);
        if (!transfer.isValid) return transfer;
    }

    // Selezione CheckIn e CheckOut
    if (step === 1) {
        const { checkin_date, checkin_time, checkout_date, checkout_time } = formData;

        if (!checkin_date || !checkin_time || !checkout_date || !checkout_time) {
            return { isValid: false, messageKey: 'stepper.validation.date' };
        }

        const checkinDateTime = new Date(`${checkin_date}T${checkin_time}`);
        const checkoutDateTime = new Date(`${checkout_date}T${checkout_time}`);

        return checkinDateTime < checkoutDateTime
            ? { isValid: true }
            : { isValid: false, messageKey: 'stepper.validation.date' };
    }
    // Selezione Veicoli
    if (step === 2) {
        const allVehiclesValid = formData.vehicles.every((v) => v.vehicleType && v.vehicleLength);
        if (allVehiclesValid) {
            return { isValid: true };
        }
        return { isValid: false, messageKey: 'stepper.validation.vehicles' };
    }
    // Selezione Transfer
    if (step === 3) {
        const validationResult = validateTransferStep(formData);
        return validationResult;
    }
    // Inserimento Dati Personali
    if (step === 5) {
        if (
            formData.customer_name &&
            formData.customer_surname &&
            formData.customer_email &&
            formData.customer_phone &&
            formData.personal_data &&
            formData.payment_terms
        ) {
            if (isValidPhoneNumber(formData.customer_phone)) {
                return { isValid: true };
            }
            return {
                isValid: false,
                messageKey: 'contact.phone_error',
                isPhoneError: true,
            };
        }
        return { isValid: false, messageKey: 'stepper.validation.personal_info' };
    }
    return { isValid: true }; // Per step 4 (preventivo)
};

// Validazione dello step 3 (Transfer)
const validateTransferStep = (formData) => {
    if (formData.has_transfer) {
        if (!formData.transfer_type) {
            return {
                isValid: false,
                messageKey: 'stepper.validation.transfer',
            };
        }

        const isOutbound = formData.transfer_type === 'outbound' || formData.transfer_type === 'outbound_return';
        const isReturn = formData.transfer_type === 'return' || formData.transfer_type === 'outbound_return';

        const isOutboundPlaceValid = () => {
            switch (formData.dropoff_place) {
                case 'harbour':
                    return !!formData.embark_detail;
                case 'city':
                case 'other':
                    return !!formData.dropoff_place_detail;
                case 'station':
                    return true;
                default:
                    return false;
            }
        };

        const isReturnPlaceValid = () => {
            switch (formData.pickup_place) {
                case 'harbour':
                    return !!formData.disembark_detail;
                case 'city':
                case 'other':
                    return !!formData.pickup_place_detail;
                case 'station':
                    return true;
                default:
                    return false;
            }
        };

        const isReturnTimeValid = () => {
            switch (formData.pickup_place) {
                case 'harbour':
                    return !!formData.disembark_time;
                case 'station':
                    return !!formData.train_arrival_time;
                case 'city':
                case 'other':
                    return !!formData.pickup_time;
                default:
                    return true;
            }
        };

        const outboundConditionsMet = isOutbound ? formData.passengers_outbound > 0 && isOutboundPlaceValid() : true;
        const returnConditionsMet = isReturn
            ? formData.passengers_return > 0 && isReturnPlaceValid() && isReturnTimeValid()
            : true;

        if (outboundConditionsMet && returnConditionsMet) {
            return { isValid: true };
        } else {
            return {
                isValid: false,
                messageKey: 'stepper.validation.transfer',
            };
        }
    }
    return { isValid: true };
};
